export { default } from './PickANumber.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PickANumber/index.js